export default __webpack_public_path__ + "static/media/business.e44c8115.svg";